import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { cutString, encodeforspace, encodeIndustryName } from '../../utils/helper';
import { isEmpty } from '../../common/utils'

export class OtherCompanies extends Component {

    constructor(props) {
        super(props)
        this.state = {
            competitorModel: '',
        }
    }
    handleChange(e) {
        this.setState({ competitorModel: e.target.value });
    }

    
    getQueryStrings(location) {

        var assoc = {};
        var decode = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")); };
        var queryString = location.search.substring(1);
        var keyValues = queryString.split('&');

        for (var i in keyValues) {
            var key = keyValues[i].split('=');
            if (key.length > 1) {
                assoc[decode(key[0])] = decode(key[1]);
            }
        }

        return assoc;
    }
    order(name) {
        const query = this.getQueryStrings(this.props.location.location);
        let orderby = query.orderby || 'asc';
        if (name == query.order) {
            orderby = orderby == 'asc' ? 'desc' : 'asc';
        }
        return `order=${name}&orderby=${orderby}`
    }

    OrderArrow = ({ name }) => {

        const query = this.getQueryStrings(this.props.location.location);
        let orderby = query.orderby || 'asc';
        if (name == query.order) {
            orderby = orderby == 'asc' ? 'desc' : 'asc';
        }
        let dir = orderby == 'asc' ? 'up' : 'down';
        if (orderby === 'asc') {
            return (
                <i style={
                    {
                        fontFamily: "fontawesome",
                        fontStyle: "normal"
                    }
                } class="fas fa-sort-down"></i>
            );
        } else {
            return (<i
                style={
                    {
                        fontFamily: "fontawesome",
                        fontStyle: "normal"
                    }
                }
                class="fas fa-sort-up"></i>);
        }

    }
    render() {
        const { data, city } = this.props;

        if (isEmpty(data)) {
            return null;
        }

        return (<React.Fragment>


            <div className="ads-wrapper">
                <h2 id="competitors" className="google-ads">Other Companies in {city} </h2>
                <a href='/export_list'>
                    <img src={`/static/img/export.png`} width='48px' />
                </a>
            </div>
            <table className="table table-bordered cstm-table">
                <thead>
                    <tr style={{ backgroundColor: 'rgb(71, 72, 102)', color: 'white' }}>
                        <th scope="col">
                            Company Name
                            {/* <Link to={`/company/${encodeforspace(this.props.company.company_name)}?${this.order('company_name')}`}>
                               
                               
                                <this.OrderArrow name="company_name"></this.OrderArrow>
                                
                            </Link> */}

                        </th>
                        <th scope="col">
                            Revenue
                            {/* <Link to={`/company/${encodeforspace(this.props.company.company_name)}?${this.order('estimated_revenues')}`}>
                               
                                <this.OrderArrow name="estimated_revenues"></this.OrderArrow>
                            </Link> */}
                        </th>
                        <th scope="col">
                            Number of Employees
                            {/* <Link to={`/company/${encodeforspace(this.props.company.company_name)}?${this.order('current_employees')}`}>
                                     
                                <this.OrderArrow name="current_employees"></this.OrderArrow>
                            </Link> */}
                        </th>
                        <th scope="col">
                            Employee Growth
                            {/* <Link to={`/company/${encodeforspace(this.props.company.company_name)}?${this.order('employee_growth')}`}>
                               
                                <this.OrderArrow name="employee_growth"></this.OrderArrow>

                            </Link> */}
                        </th>
                        <th scope="col">
                            Total Funding
                            {/* <Link to={`/company/${encodeforspace(this.props.company.company_name)}?${this.order('total_funding')}`}>
                               
                                <this.OrderArrow name="total_funding"></this.OrderArrow>
                            </Link> */}
                        </th>
                        {/* <th scope="col">
                            Online Review
                        </th>
                        <th scope="col">
                            Pricing
                        </th> */}
                    </tr>
                </thead>
                <tbody>
                    {data.map((company, index) => {
                        const { company_name, estimated_revenues, current_employees, last_employees, total_funding_float, url, linkedin_url, pricing, rating } = company;
                        const total_funding = !total_funding_float ? 'N/A' :
                            total_funding_float > 1000 ? `$${Math.round(total_funding_float / 100) / 10}B` :
                                `$${total_funding_float}M`;
                        const total_pricing = pricing ? pricing : 'N/A';
                        const _estimated_revenues = estimated_revenues ? `$${Math.round(estimated_revenues / 100000) / 10}M` : 'N/A';
                        const growth = current_employees && last_employees ? Math.round((current_employees - last_employees) / last_employees * 100) + '%' : 'N/A';
                        const competitorAd = company.sort < 100 && company.competitor_ad_text != '' && company.competitor_ad_link != '' ?
                            (
                                <div style={{ display: 'inline-block', marginLeft: 20 }}>
                                    <a href={company.competitor_ad_link} className="btn btn-primary btn-sm" target="blank" >
                                        {company.competitor_ad_text}
                                    </a>
                                </div>
                            ) : false
                        return (<tr key={index + 'similar'}>
                            <td>
                                <div style={{ display: 'inline-block' }}>
                                    #{index + 1}
                                </div>
                                <div style={{ display: 'inline-block', marginLeft: 8 }}>
                                    <a href={`//${url}`} target="_blank" onClick={(e) => { e.stopPropagation(); }} style={{ marginRight: 5, fontSize: 15, color: '#13135c', textDecoration: "none" }}>
                                        <img src={`https://www.google.com/s2/favicons?domain=${url}`} style={{ marginRight: 5, width: 18 }} />
                                    </a>
                                    <Link to={`/company/${encodeforspace(company_name)}`} style={{ marginRight: 5, fontSize: 15, textDecoration: 'none' }}>{cutString(company_name, 15)}</Link>
                                </div>


                                {/* <div style={{ display: 'inline-block', marginLeft: 8 }}>
                                    <a href={linkedin_url} target="_blank" onClick={(e) => { e.stopPropagation(); }}>
                                        <LinkedinIcon size={15} />
                                    </a>


                                </div> */}
                                {competitorAd}
                            </td>
                            <td>{_estimated_revenues}</td>
                            <td>{current_employees}</td>
                            <td>{growth}</td>
                            <td>{total_funding}</td>
                            {/* <td>{!rating ? '-' : rating + '/5'}</td>
                            <td>{total_pricing}</td> */}
                        </tr>);
                    })}
                </tbody>
            </table>
           
        </React.Fragment>);
    }
}
// export const Competitors = ({ data, industry, key, companyName }) => {
//     const [competitorModel, setcompetitor] = React.useState('');



// };



// WEBPACK FOOTER //
// ./client/src/views/CompanyDetail/OtherCompanies.js